/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Plan_SelectInputs */

const cs_auth_signup_plan_select = /** @type {(inputs: Auth_Signup_Plan_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte tarif (nepovinné)…`)
};

const en_auth_signup_plan_select = /** @type {(inputs: Auth_Signup_Plan_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a plan (optional)…`)
};

/**
* | output |
* | --- |
* | "Select a plan (optional)…" |
*
* @param {Auth_Signup_Plan_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_plan_select = /** @type {((inputs?: Auth_Signup_Plan_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Plan_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_plan_select(inputs)
	return cs_auth_signup_plan_select(inputs)
});